module.exports = __webpack_public_path__ + "img/mileage.7d756224.png";